import React from 'react';
import Header from '../components/Header/Header';
import SeperateHero from '../components/SpecialJoin/SeperateHero';
import Banner from '../components/EventCard/EventBanner';
import Event from '../components/EventCard/Events';
import BreadcrumbSchema from "./BreadcrumbSchema";

function Events() {
  return (
    <div
      style={{
         background: "linear-gradient(to bottom right, rgb(59 130 246 / 0.1), rgb(168 85 247 / 0.1));",
      }}
    >
      <BreadcrumbSchema />
      <Header />
      
      {/* Add top margin here */}
      <div className="mt-16">
        <Banner />
      </div>

      <Event />
      <SeperateHero />
    </div>
  );
}

export default Events;
